import { isEmpty, checkNested } from 'srcReact/helpers/validator'
import { getCookie, isNative, setCookie } from 'srcReact/helpers/utils'

export const setObjectWithInfo = (obj) => {
  if (obj.hasOwnProperty('info')) {
    return obj
  }
  return { info: obj }
}

export const isUserAuthorized = () => {
  if (getCookie('usr_logged') !== null && getCookie('uaccess_token') !== null && localStorage.getItem('user')) {
    return true
  } else {
    setCookie('usr_logged', '', -1)
    setCookie('uaccess_token', '', -1)
    localStorage.removeItem('user')
    //old tokens - need to remove after couple of months
    setCookie('user_token', '', -1)
    setCookie('user_logged', '', -1)
    return false
  }
}

export const accessExits = (organization) => {
  if (!isEmpty(organization.info) && !isEmpty(organization.info.my_access)) {
    return true
  }
  return false
}

export const rightsExit = (organization) => {
  if (!isEmpty(organization.info) && !isEmpty(organization.info.my_rights)) {
    return true
  }
  return false
}

export const isCurrentUser = (user) => {
  const current_user = JSON.parse(localStorage.getItem('user'))
  if (current_user == undefined) {
    return false
  }
  if (current_user.id == user.info.resourceKey) {
    return true
  }
  return false
}

export const isWorkplaceManagerOf = (organization, workplace) => {
  if (
    checkNested(organization, 'info', 'my_access', 'role_as_workplace_manager', 'workplace_list') &&
    (checkNested(workplace, 'info', 'resourceKey') || checkNested(workplace, 'info', 'id'))
  ) {
    const id = checkNested(workplace, 'info', 'resourceKey') ? workplace.info.resourceKey : workplace.info.id
    if (organization.info.my_access.role_as_workplace_manager.workplace_list.includes(id.toString())) {
      return true
    }
  }
  return false
}

export const isWorkplaceManagerOfAtLeastOne = (organization) => {
  if (organization == undefined) {
    return false
  }
  const orga = setObjectWithInfo(organization)
  if (
    checkNested(orga, 'info', 'my_access', 'role_as_workplace_manager', 'quantity') &&
    orga.info.my_access.role_as_workplace_manager.quantity > 0
  ) {
    return true
  }
  return false
}

export const isWorkplaceManagerOfMany = (organization) => {
  if (organization == undefined) {
    return false
  }
  const orga = setObjectWithInfo(organization)
  if (
    checkNested(orga, 'info', 'my_access', 'role_as_workplace_manager', 'quantity') &&
    orga.info.my_access.role_as_workplace_manager.quantity > 1
  ) {
    return true
  }
  return false
}

export const isWorkplaceManagerOfOne = (organization) => {
  if (organization == undefined) {
    return false
  }
  const orga = setObjectWithInfo(organization)
  if (
    checkNested(orga, 'info', 'my_access', 'role_as_workplace_manager', 'quantity') &&
    orga.info.my_access.role_as_workplace_manager.quantity == 1
  ) {
    return true
  }
  return false
}

export const displayRole = (user) => {
  if (isWorkplaceManager(user)) {
    return 'workplace_manager'
  }

  return 'workplace_member'
}

export const hasRole = (user, role) => {
  if (checkNested(user, 'info', 'roles') && user.info.roles.includes(role)) {
    return true
  }
  if (checkNested(user, 'roles') && user.roles.includes(role)) {
    return true
  }
  return false
}

export const isWorkplaceManager = (user) => {
  return hasRole(user, 'workplace-manager')
}

export const isWorkplaceFinanceManager = (user) => {
  return hasRole(user, 'workplace-finance-manager')
}

export const canCreateGroup = (organization) => {
  if (
    checkNested(organization, 'info', 'my_rights', 'can_create_groups') &&
    organization.info.my_rights.can_create_groups == true
  ) {
    return true
  }
  return false
}

export const getIdExternalApiAuth = () => {
  const idExternalApiAuth = localStorage.getItem('id_external_api_auth')
  if (idExternalApiAuth) {
    return idExternalApiAuth
  }
  return 0
}
